export default __webpack_public_path__ + "grid-3-active-dtk.png";